import { MapsScreenLazy } from './mapsScreenLazy';

const props = [];

export const MapsScreenLazyDirective = (reactDirective) => reactDirective(MapsScreenLazy, props, null);
MapsScreenLazyDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('mapsScreen', MapsScreenLazyDirective);
